module.exports = __webpack_public_path__ + "img/07@2x.0ce485eb.png";